import { render } from "./AdminSidebarSection.vue?vue&type=template&id=200d3dcc"
import script from "./AdminSidebarSection.vue?vue&type=script&lang=js"
export * from "./AdminSidebarSection.vue?vue&type=script&lang=js"

import "./AdminSidebarSection.vue?vue&type=style&index=0&id=200d3dcc&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__